var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-menu",
    {
      attrs: {
        bottom: "",
        left: "",
        "nudge-bottom": "48",
        "nudge-right": "18",
        "content-class": "navigation-context-menu",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "span",
                _vm._g(
                  _vm._b(
                    { class: [_setup.iconProduct, "main-icon"] },
                    "span",
                    attrs,
                    false
                  ),
                  on
                )
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-list",
        { staticClass: "list" },
        [
          _c("v-list-item", { staticClass: "list-title" }, [
            _vm._v(" " + _vm._s(_setup.text.ecosystem) + " "),
          ]),
          _vm._l(_setup.toolList, function (tool) {
            return _c(
              "v-list-item",
              {
                key: tool.name,
                staticClass: "list-item",
                on: {
                  click: function ($event) {
                    return _setup.redirect(tool.url)
                  },
                },
              },
              [
                _c("span", { class: [tool.icon, "lf-icon__lg"] }),
                _c("span", [_vm._v(_vm._s(tool.name))]),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }